var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wheel_wrap"},[(_vm.showLucky === true)?_c('GluecksRad',{ref:"luckyW",staticClass:"radContainer",attrs:{"wheeldata":_vm.wheeldata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }